import { useState } from "react";

import RestCardProduct from "./RestCardProduct";
import OptionsModal from "./OptionsModal";
import { useStoreRest } from "../storeRest";

function RestProducts({ shopId, categoryId, updateMsg, products }) {
  const shopProducts = useStoreRest(
    (state) => state.shops[shopId]?.products?.[categoryId],
  );

  const [openModal, setOpenModal] = useState(false);
  const [options, setOptions] = useState(null);

  const source = products ?? shopProducts;
  if (!source) return null;

  function closeModal() {
    setOptions(null);
    setOpenModal(false);
  }

  function handleModal(opts) {
    setOpenModal(true);
    setOptions(opts);
  }

  const _products = Array.from(source.values())
    .map((p) => ({ ...p, _n: p.name.toLowerCase() }))
    .sort((a, b) => a._n.localeCompare(b._n));

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 w-full my-3 sm:px-2">
      {_products.map((pdt, idx) => (
        <RestCardProduct
          key={idx}
          product={pdt}
          shopId={shopId}
          updateMsg={updateMsg}
          handleModal={handleModal}
          closeModal={closeModal}
        />
      ))}
      {options && (
        <OptionsModal
          open={openModal}
          options={options}
          shopId={shopId}
          onClose={closeModal}
          updateMsg={updateMsg}
        />
      )}
    </div>
  );
}

export default RestProducts;
